import { cn } from '@altify/components';
import { uniqueId } from 'lodash/fp';
import React, { useState } from 'react';
import { Placement } from 'tippy.js';
import appHelpers from 'utils/app-urls';
import { Tooltip } from '../Tooltip/Tooltip';

const cdnURL = appHelpers.getCDNUrl();
const infoIcon = `${cdnURL}assets/products/general/info.svg`;

export function InfoTooltip({
  children,
  clickable,
  delayHide,
  placement,
  className,
}: {
  className?: string;
  clickable?: boolean;
  delayHide?: number;
  placement?: Placement;
  children: React.ReactNode;
}) {
  const [id, _] = useState(uniqueId('info'));

  return (
    <Tooltip
      id={id}
      content={children}
      darkBg
      interactive={clickable}
      placement={placement}
      delay={[null, !delayHide ? null : delayHide]}>
      <img
        src={infoIcon}
        alt="info"
        width="15px"
        height="15px"
        className={cn('hover:opacity-80', className)}
      />
    </Tooltip>
  );
}
